import { clsx } from 'clsx';
import { AlertCircle, CheckCircle, Info, XCircle, X } from 'lucide-react';

interface AlertProps {
  variant?: 'info' | 'success' | 'warning' | 'error';
  title?: string;
  children: React.ReactNode;
  onClose?: () => void;
  className?: string;
}

export function Alert({ variant = 'info', title, children, onClose, className }: AlertProps) {
  const variantConfig = {
    info: {
      bg: 'bg-info/10 border-info/30',
      icon: <Info className="w-5 h-5 text-info" />,
      titleColor: 'text-info',
    },
    success: {
      bg: 'bg-success/10 border-success/30',
      icon: <CheckCircle className="w-5 h-5 text-success" />,
      titleColor: 'text-success',
    },
    warning: {
      bg: 'bg-warning/10 border-warning/30',
      icon: <AlertCircle className="w-5 h-5 text-warning" />,
      titleColor: 'text-warning',
    },
    error: {
      bg: 'bg-error/10 border-error/30',
      icon: <XCircle className="w-5 h-5 text-error" />,
      titleColor: 'text-error',
    },
  };

  const config = variantConfig[variant];

  return (
    <div
      className={clsx(
        'flex gap-3 p-4 rounded-lg border',
        config.bg,
        className
      )}
      role="alert"
    >
      <div className="flex-shrink-0">{config.icon}</div>
      <div className="flex-1 min-w-0">
        {title && (
          <h4 className={clsx('font-medium mb-1', config.titleColor)}>{title}</h4>
        )}
        <div className="text-sm text-text-secondary">{children}</div>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="flex-shrink-0 text-text-muted hover:text-text-primary transition-colors"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}

